var map = {
	"./en/card_4_2.png": "1XCF",
	"./es/card_4_2.png": "Qn6K",
	"./pt/card_4_2.png": "c7JO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ZMG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_4_2\.png$
// module id = 5ZMG
// module chunks = 0